import { AwardCard } from "./achievement-cards";
import { motion, Variants } from "framer-motion";

// Import logos
import reactLogo from "../../resources/react.png";
import nodeLogo from "../../resources/node.png";
import awsLogo from "../../resources/aws.png";
import postgresLogo from "../../resources/postgres.png";
import appleLogo from "../../resources/Apple_logo_black.svg";
import googleCloudLogo from "../../resources/google cloud.png";
import androidLogo from "../../resources/android.png";
import stripeLogo from "../../resources/stripe.png";

// Data with technology logos
const awardsData = [
  {
    icon: (
      <img
        src={reactLogo}
        alt="React logo"
        className="h-8 w-8 sm:h-12 sm:w-12 md:h-16 md:w-16 object-contain grayscale"
      />
    ),
    title: "Frontend",
    description: "React",
  },
  {
    icon: (
      <img
        src={nodeLogo}
        alt="Node.js logo"
        className="h-8 w-8 sm:h-12 sm:w-12 md:h-16 md:w-16 object-contain grayscale"
      />
    ),
    title: "Backend",
    description: "Node.js",
  },
  {
    icon: (
      <img
        src={awsLogo}
        alt="AWS logo"
        className="h-8 w-8 sm:h-12 sm:w-12 md:h-16 md:w-16 object-contain grayscale brightness-0 invert"
      />
    ),
    title: "Platform",
    description: "AWS",
  },
  {
    icon: (
      <img
        src={postgresLogo}
        alt="PostgreSQL logo"
        className="h-8 w-8 sm:h-12 sm:w-12 md:h-16 md:w-16 object-contain grayscale"
      />
    ),
    title: "Database",
    description: "PostgreSQL",
  },
  {
    icon: (
      <img
        src={appleLogo}
        alt="Apple logo"
        className="h-8 w-8 sm:h-12 sm:w-12 md:h-16 md:w-16 object-contain grayscale brightness-0 invert"
      />
    ),
    title: "Mobile",
    description: "iOS Development",
  },
  {
    icon: (
      <img
        src={googleCloudLogo}
        alt="Google Cloud logo"
        className="h-8 w-8 sm:h-12 sm:w-12 md:h-16 md:w-16 object-contain grayscale"
      />
    ),
    title: "Platform",
    description: "Google Cloud",
  },
  {
    icon: (
      <img
        src={androidLogo}
        alt="Android logo"
        className="h-8 w-8 sm:h-12 sm:w-12 md:h-16 md:w-16 object-contain grayscale"
      />
    ),
    title: "Mobile",
    description: "Android",
  },
  {
    icon: (
      <img
        src={stripeLogo}
        alt="Stripe logo"
        className="h-8 w-8 sm:h-12 sm:w-12 md:h-16 md:w-16 object-contain grayscale"
      />
    ),
    title: "Payments",
    description: "Stripe",
  },
];

// Framer Motion animation variants
const containerVariants: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants: Variants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  },
};

export default function AwardCardGrid() {
  return (
    <div className="w-full max-w-6xl mx-auto px-4 sm:p-4" aria-label="Technologies">
      <motion.div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-6 sm:gap-8 md:gap-10"
        role="list"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {awardsData.map((award, index) => (
          <motion.div key={index} variants={itemVariants} role="listitem">
            <AwardCard
              icon={award.icon}
              title={award.title}
              description={award.description}
            />
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}

